var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',[_c('v-list-item',{attrs:{"to":{ name: '' }}},[_c('v-list-item-title',[_vm._v("Таблица прогресса выполнения заданий")])],1)],1),_c('router-view',{attrs:{"name":"activist_metrics"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }